/**
 * Return which component to render based on it's data/context
 * @param {Object} item nav menu item
 */
export const resolveVerticalNavMenuItemComponent = (item) => {
  if (item.header) return 'VerticalNavMenuSectionHeader';
  if (item.children) return 'VerticalNavMenuGroup';
  return 'VerticalNavMenuLink';
};

/**
 * Return which component to render based on it's data/context
 * @param {Object} item nav menu item
 */
export const resolveHorizontalNavMenuItemComponent = (item) => {
  if (item.children) return 'HorizontalNavMenuGroup';
  return 'HorizontalNavMenuLink';
};

/**
 * Check if nav-link is active
 * @param {Object} link nav-link object
 */
export const isNavLinkActive = (link, currentURL, routerProps) => {
  return (
    currentURL === link
    || (routerProps
      && routerProps.meta
      && routerProps.meta.to
      && routerProps.meta.to === link)
  );
  // return currentURL === link
};

/**
 * Check if the given item has the given url
 * in one of its children
 *
 * @param item
 * @param activeItem
 */
export const hasActiveChild = (item, currentUrl) => {
  const { children } = item;

  if (!children) {
    return false;
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const child of children) {
    if (child.children) {
      if (hasActiveChild(child, currentUrl)) {
        return true;
      }
    }

    // Check if the child has a link and is active
    if (
      child
      && child.to
      && currentUrl
      && (child.to === currentUrl)
    ) {
      return true;
    }
  }

  return false;
};

/**
 * Check if this is a children
 * of the given item
 *
 * @param children
 * @param openGroup
 * @param currentActiveGroup
 */
export const removeChildren = (children, openGroup, currentActiveGroup) => {
  children.forEach((child) => {
    if (!currentActiveGroup.includes(child.id)) {
      const index = openGroup.indexOf(child.id);
      if (index > -1) openGroup.splice(index, 1);
      if (child.children) removeChildren(child.children, openGroup, currentActiveGroup);
    }
  });
};

const checkForVisibleChild = (/* arr */) => {
  return true;
  /*
  return arr.some((i) => {
    if (i.children) {
      return checkForVisibleChild(i.children);
    }
    return false;
  });
  */
};

export const canViewMenuGroup = (/* item */) => {
  return true;
  /*
  const hasAnyVisibleChild = item.children && checkForVisibleChild(item.children);

  if (!(item.action && item.resource)) {
    return hasAnyVisibleChild;
  }
  return hasAnyVisibleChild; // ability.can(item.action, item.resource) && hasAnyVisibleChild;
  */
};
